<template>
  <div class="relative"
       v-on-clickaway="hide">
    <div v-if="picked"
         class="bg-gray-100 rounded px-3 py-2 border border-gray-100">
      <div class="font-semibold flex justify-between">
        {{ picked.name }}
        <button type="button"
                @click="clear">
          <BaseIcon name="x" />
        </button>
      </div>
      <div class="text-gray-500 text-sm">
        {{ picked.status ? picked.status.name : '' }}
      </div>
    </div>
    <template v-else>
      <input class="form-input w-full"
             autocomplete="off"
             type="text"
             placeholder="Zoek een contact"
             ref="input"
             :class="{ 'error': error }"
             :name="name"
             :required="required"
             v-model="search"
             @focus="focus">
      <div class="form-error"
           v-if="error">{{ error }}</div>
      <div class="absolute bg-white w-full shadow py-2 z-20 overflow-y-auto mb-5"
           ref="menu"
           v-if="showMenu">
        <div class="flex justify-between px-4 py-2 hover:bg-blue-100 cursor-pointer group"
             v-for="contact in results"
             :key="contact.id"
             @click.prevent="pick(contact)">
          {{ contact.name }}
          <div class="text-gray-500"
               v-if="contact.status">{{ contact.status.name }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { get } from "@/api.js";
import { mixin as clickaway } from "vue-clickaway";

export default {
  inheritAttrs: false,

  mixins: [clickaway],

  model: {
    prop: "value",
    event: "picked"
  },

  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
      type: [String, Boolean],
      default: false
    },
    prePicked: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      search: "",
      picked: null,
      contacts: [],
      hasFocus: false
    };
  },

  created() {
    if (this.prePicked) {
      this.pick(this.prePicked)
    }
  },

  computed: {
    validationError() {
      if (!this.picked && this.required) return "Selecteer een contact";
      else return null;
    },

    results() {
      return this.contacts.slice(0, 5);
    },

    showMenu() {
      return this.search && this.results.length && this.hasFocus;
    }
  },

  watch: {
    search() {
      if (this.search) {
        this.hasFocus = true;
        get(`search`, { query: this.search }).then(
          response => (this.contacts = response.data)
        );
      } else {
        this.search = [];
      }
    }
  },

  methods: {
    clear() {
      this.picked = null;
      this.$emit("picked", null);
      this.$nextTick(() => this.$refs.input.focus());
    },

    pick(contact) {
      this.picked = contact;
      this.hasFocus = false;
      this.$emit("picked", contact.id);
    },

    focus() {
      this.hasFocus = true;
    },

    hide() {
      this.hasFocus = false;
    }
  }
};
</script>
